var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart89-template',{attrs:{"board-ids":[288],"data-type":_vm.dataType,"graph-id":90,"date-field":"$.body.stdInfo.점검일","count-fields":['body.stdInfo.재해형태'],"title":"현장순회점검 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }